import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { exploreTrue } from "./exploreTrueAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    Attributes: [],
    UsedQuestionsId:[],
    LastCard: false,
}

export const exploreTrueAsync = createAsyncThunk(
    "/exploretrue",
    async ({gender, player},{getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.exploreTrue.UsedQuestionsId  
            const sessionid = state.gameStatus.sessions['explore'].sessionId  
            
            
            const response = await exploreTrue(gender, player, usedid, sessionid);
            return response
        } catch (error) {
            console.error("Error in exploreTrueAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)
export const exploreTrueSlice = createSlice({
    name: "exploretrue",
    initialState,
    reducers: {
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.Attributes = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(exploreTrueAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(exploreTrueAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectExploreTrue = (state) => state.exploreTrue
export const {resetState} = exploreTrueSlice.actions;

export default exploreTrueSlice.reducer